//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => direction};
    align-items: ${({ direction }) => direction === "row" ? "center" : "flex-start" };
    flex-wrap: wrap;
    gap: 10px;
    transition: 0.4s;
    width: ${({ width }) => width};
    min-width: ${({ containerMinWidth = "unset" }) => containerMinWidth};
    & label {
        font-weight: 600;
        font-size: 14px;
        color: var(--dark-4);
        transition: 0.35s;
    }
    &.disabled label {
        color: var(--purple-4);
    }
`;
export const ContainerCustomSelect = styled.div`
    position: relative;
    transition: inherit;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: ${({ width }) => width || "500px"};
    &:not(.disabled):focus {
        & > div {
            border-color: var(--purple-1) !important;
        }
        & svg {
            fill: var(--purple-2);
        }
    }
`;
export const OptionsBlock = styled.ul`
    margin: 0;
    padding: 0;
    width: 100%;
    list-style: none;
    position: fixed;
    z-index: 50;
    border-radius: 4px;
    background-color: var(--light-1);
    box-shadow: 0px 5px 8px #4A4A4A33;
    max-height: 185px;
    overflow-y: auto;
    display: none;
    &.show {
        display: block;
    }
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: var(--light-gray-4);
    }
`;
export const ContentCustomSelect = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;
export const SelectText = styled.div`
    min-width: ${({ minWidth = "210px" }) => minWidth};
    position: relative;
    padding: 11px 16px;
    font-weight: 500;
    font-size: 14px;
    width: 100%;
    outline: none;
    background-color: var(--light-1);
    color: var(--light-gray-5);
    border: 1px solid var(--light-gray-4);
    border-radius: 5px;
    transition: 0.4s;
    cursor: pointer;
    & span {
        font-size: 13px;
        user-select: none;
        display: block;
        width: ${({ minWidth = "210px" }) => `calc(${minWidth} - 60px)`};
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    & svg {
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        pointer-events: none;
        fill: var(--light-gray-5);
    }
    &.disabled {
        color: var(--purple-4);
        border-color: var(--purple-4);
        pointer-events: none;
        & svg {
            fill: var(--purple-4);
        }
    }
    &.error {
        border-color: var(--red-3);
    }
`;
export const ErrorText = styled.span`
    color: var(--red-2);
    font-size: 14px;
    font-weight: 490;
    margin-left: 10px;
`;
export const ContainerSelectOption = styled.li`
    padding: 10px 16px;
    font-size: 14px;
    margin: 0;
    color: var(--dark-4);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    transition: 0.35s;
    cursor: pointer;
    &.selected, &:hover {
        background-color: var(--light-blue-1);
    }
`;